<script>
import api from "@services/api";
import dateRangePickerConfig from "@configs/dateRangePickerConfig";
import DateRangePicker from "vue2-daterange-picker";

export default {
  components: {DateRangePicker},
  data: () => ({
    selected: '',
    periodo: null,
    customRanges: dateRangePickerConfig.customRanges,
    maxDate: dateRangePickerConfig.maxDate(),
    localeData: dateRangePickerConfig.localeData,
    dateRange: { startDate: new Date(), endDate: new Date() },
    clienteList: {},
    consultorList: {},
    ComboItem: {
      dataInicial: new Date(),
      dataFinal: new Date(),
      selected: null
    },
    contratoList: null,
    clienteId: null,
    clienteContratoList: null,
    contratoAtivoList: null,
    contratoId: null,
    projetoList: null,
    projetoId: null
  }),  
  created() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let endDate = new Date();
    endDate.setHours(0, 0, 0, 0);
    let startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
    startDate.setHours(0, 0, 0);
    

    this.dateRange = {
      startDate: startDate,
      endDate: endDate
    };

    this.getClienteList();
        
    if(this.user.perfil !== "Consultor"){      
      this.getConsultorList();
    }
  },
  watch:{
    selected: function(){
      this.clienteId = this.selected;      
      this.projetoId =null;
      this.contratoId =null;

      this.postEmit();

      this.setEstado(this.ComboItem.selected);
      
      this.getClienteContratoList();
      this.getProjetoList();
      
    },
    projetoId: function(){
      this.postEmit();
    },
    contratoId(){
      this.postEmit();
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.getEstado();
  },
  methods: {
    getConsultorList() {
      api
        .get(`Crud/Consultor/ConsultoresPorDatas`,{
         params: {           
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate            
          }
      })
        .then(response => (this.consultorList = response.data["data"]));        
    },
    getEstado(){
      var estadoCombo = JSON.parse(localStorage.getItem("@saveStateCombo"));      
        this.selected = estadoCombo;        
        this.ComboItem.selected = estadoCombo;
    },
    setEstado(value){
      localStorage.setItem('@saveStateCombo', JSON.stringify(value));      
    },
    updateRange(){
      this.selected = undefined;
      this.getClienteList();
      this.getConsultorList();
    },
    getClienteContratoList() {        
      api.get(`crud/Contrato/ContratoAtivoNasDatas`,{
        params: {
          dataInicial: this.dateRange.startDate,
          dataFinal: this.dateRange.endDate,
          clienteId: this.clienteId           
        }
      }).then(response => {
        this.clienteContratoList = response.data["data"];
        this.contratoAtivoList = this.clienteContratoList.filter(cont => cont.ativo == true);
        this.contratoList = this.contratoAtivoList.filter(cont => cont.clienteId == this.clienteId)
      });
    },
    getClienteList() {
      api
        .get(`crud/Expediente/clientesPorData`,{
         params: {           
            dataInicial: this.dateRange.startDate,
            dataFinal: this.dateRange.endDate            
          }
      })
        .then(response => (this.clienteList = response.data["data"]));
    },
    getProjetoList() {
      if (this.clienteId) {
        api
          .get(`crud/Expediente/Projetos`, {
            params: {
              clienteId: this.clienteId,
              dataInicial: this.dateRange.startDate,
              dataFinal: this.dateRange.endDate,
            }
          })
          .then(response => {
            this.projetoList = response.data["data"];            
          });
      }
    },
    postEmit(){
      this.ComboItem.dataFinal = this.dateRange.endDate;
      this.ComboItem.dataInicial = this.dateRange.startDate;
      this.ComboItem.selected = this.selected;
      this.ComboItem.clienteId = this.clienteId;
      this.ComboItem.projetoId = this.projetoId;
      
      this.ComboItem.contratoId = this.contratoId;      
      this.$emit("AtualizarData", this.ComboItem)
      
    }
  }
};
</script>

<template>
  <div class="mb-2">
      <div class="row">
          <b-form-group id="input-group-1" label="Período" label-for="picker" class="mb-2 col-md-3">
            <date-range-picker
              ref="picker"
              :opens="'right'"
              :locale-data="localeData"
              :ranges="customRanges()"
              :maxDate="maxDate"
              :showWeekNumbers="true"
              :autoApply="true"
              v-model="dateRange"
              @update="updateRange"
              :linkedCalendars="true"
            >
              <template v-slot:input="picker" style="min-width: 350px;">
                {{ picker.startDate | formatField("date") }} -
                {{ picker.endDate | formatField("date") }}
              </template>
            </date-range-picker>
          </b-form-group>
        
        <b-form-group
          id="input-group-1"
          label="Cliente/Consultor"
          label-for="select"
          class="col-md-3"
        >
          <b-form-select v-model="selected">
            <b-form-select-option :value="{contratoId: null }"
              >Todos</b-form-select-option
            >
            <b-form-select-option-group v-if="this.clienteList.length > 0" label="Cliente">
             <b-form-select-option
              v-for="option in clienteList"
              :key="option.id"
              :value="option.id"
              >
              {{ option.nome }}
              </b-form-select-option>
            </b-form-select-option-group>
            <b-form-select-option-group v-if="this.consultorList.length > 0" label="Consultor">
              <b-form-select-option
                v-for="option in consultorList"
                :value="{ consultorId: option.id }"
                :key="'consultorId:' + option.id"
              >
                {{ option.nome }}
              </b-form-select-option>
            </b-form-select-option-group>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-3"
          id="input-group-1"
          label="Contrato"
          label-for="contratoId"
        >
          <b-form-select
            id="contratoId"
            v-model="contratoId"            
          >
            <b-form-select-option  :value="undefined" 
              >Todos os contratos</b-form-select-option
            >
            <b-form-select-option
              v-for="option in contratoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-3"
          id="input-group-1"
          label="Projeto"
          label-for="projetoId"
        >
          <b-form-select
            id="projetoId"
            v-model="projetoId"                     
          >
            <b-form-select-option :value="undefined"
              >Todos os Projetos</b-form-select-option
            >
            <b-form-select-option
              v-for="option in projetoList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
        
      </div>
    
  </div>
  <!-- end card-box -->
</template>

